module.exports = __webpack_public_path__ + "img/home-seven-cai-logo.png";